export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-gray-900 to-black text-white pt-12 md:pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Main Footer Content */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 mb-10 md:mb-12">
          {/* Brand Column */}
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <i className="ri-truck-line text-3xl md:text-4xl text-yellow-500"></i>
              <span className="text-xl md:text-2xl font-bold">Guincho Express</span>
            </div>
            <p className="text-gray-400 mb-5 leading-relaxed text-sm md:text-base">
              Guincho rápido, seguro e confiável. Atendimento 24 horas em todo o Brasil.
            </p>
            <div className="flex gap-3">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer"
                className="w-9 h-9 bg-white/10 rounded-full flex items-center justify-center hover:bg-yellow-500 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer"
                className="w-9 h-9 bg-white/10 rounded-full flex items-center justify-center hover:bg-yellow-500 transition-colors cursor-pointer">
                <i className="ri-instagram-fill text-lg"></i>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer"
                className="w-9 h-9 bg-white/10 rounded-full flex items-center justify-center hover:bg-yellow-500 transition-colors cursor-pointer">
                <i className="ri-twitter-fill text-lg"></i>
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer"
                className="w-9 h-9 bg-white/10 rounded-full flex items-center justify-center hover:bg-yellow-500 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Services Column */}
          <div>
            <h3 className="text-base md:text-xl font-bold mb-4 md:mb-6">Serviços</h3>
            <ul className="space-y-2 md:space-y-3">
              {['Guincho 24 Horas','Reboque de Veículos','Transporte de Motos','Assistência em Rodovias','Troca de Pneus'].map(s => (
                <li key={s}>
                  <a href="#servicos" className="text-gray-400 hover:text-yellow-500 transition-colors cursor-pointer text-sm md:text-base">{s}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h3 className="text-base md:text-xl font-bold mb-4 md:mb-6">Fale Conosco</h3>
            <ul className="space-y-3 md:space-y-4">
              <li className="flex items-start gap-2">
                <i className="ri-phone-fill text-yellow-500 text-base md:text-xl mt-0.5"></i>
                <div>
                  <p className="text-gray-400 text-xs">Ligue Agora</p>
                  <a href="tel:+5519987030337" className="text-white font-bold hover:text-yellow-500 cursor-pointer text-sm md:text-base">(19) 98703-0337</a>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-whatsapp-fill text-yellow-500 text-base md:text-xl mt-0.5"></i>
                <div>
                  <p className="text-gray-400 text-xs">WhatsApp</p>
                  <a href="https://wa.me/5519987030337" className="text-white font-bold hover:text-yellow-500 cursor-pointer text-sm md:text-base">(19) 98703-0337</a>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-mail-fill text-yellow-500 text-base md:text-xl mt-0.5"></i>
                <div>
                  <p className="text-gray-400 text-xs">E-mail</p>
                  <a href="mailto:contato@guinchoexpress.com.br" className="text-white hover:text-yellow-500 cursor-pointer text-xs md:text-sm break-all">contato@guinchoexpress.com.br</a>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-fill text-yellow-500 text-base md:text-xl mt-0.5"></i>
                <div>
                  <p className="text-gray-400 text-xs">Horário</p>
                  <p className="text-white font-bold text-sm md:text-base">24 horas, 7 dias</p>
                </div>
              </li>
            </ul>
          </div>

          {/* Newsletter Column */}
          <div className="col-span-2 md:col-span-1">
            <h3 className="text-base md:text-xl font-bold mb-4 md:mb-6">Receba Dicas</h3>
            <p className="text-gray-400 mb-4 text-sm">
              Cadastre-se para receber dicas de manutenção e cuidados com seu veículo.
            </p>
            <form className="flex gap-2">
              <input
                type="email"
                placeholder="Seu e-mail"
                className="flex-1 px-3 py-3 rounded-xl bg-white/10 border border-white/20 text-white placeholder-gray-500 focus:outline-none focus:border-yellow-500 transition-colors text-sm"
              />
              <button type="submit"
                className="w-11 h-11 bg-yellow-500 rounded-full flex items-center justify-center hover:bg-yellow-400 transition-colors cursor-pointer shrink-0">
                <i className="ri-arrow-right-line text-black text-lg"></i>
              </button>
            </form>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="border-t border-white/10 pt-6 md:pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-3 md:gap-4 text-center">
            <p className="text-gray-400 text-xs md:text-sm">
              © {currentYear} Guincho Express. Todos os direitos reservados.
            </p>
            <div className="flex gap-4 md:gap-6">
              <a href="#" className="text-gray-400 hover:text-yellow-500 text-xs md:text-sm transition-colors cursor-pointer">Política de Privacidade</a>
              <a href="#" className="text-gray-400 hover:text-yellow-500 text-xs md:text-sm transition-colors cursor-pointer">Termos de Uso</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
